import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [highlight, setHighlight] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight * 0.6 && rect.bottom > 0;
      if (isVisible && !highlight) {
        setHighlight(true);
        // Reset after animation
        setTimeout(() => setHighlight(false), 2000);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [highlight]);
  return <section ref={sectionRef} id="pricing" className="py-32 px-4 bg-navy-900 relative overflow-hidden" data-id="element-144">
      {/* Background glow */}
      <div className="absolute inset-0 bg-radial-glow opacity-80 pointer-events-none" data-id="element-145" />

      {/* Highlight pulse when scrolled into view */}
      <motion.div className="absolute inset-0 pointer-events-none rounded-3xl" animate={highlight ? {
      boxShadow: ['0 0 0px rgba(212,168,83,0)', '0 0 60px rgba(212,168,83,0.4)', '0 0 80px rgba(212,168,83,0.2)', '0 0 0px rgba(212,168,83,0)']
    } : {}} transition={{
      duration: 2,
      ease: 'easeOut'
    }} data-id="element-146" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-147">
        <FadeIn data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/5bNhQK1tZzNNjLjKiwhqc6/portada_dos.png" alt="SOS: Bebé Duerme Cover" className="w-48 md:w-64 mx-auto rounded-xl shadow-2xl border border-gold/30 mb-12" data-id="element-149" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-4" data-id="element-151">
            Obtén el manual completo <br className="hidden md:block" data-id="element-152" />
            <span className="text-gold italic" data-id="element-153">
              "SOS: Bebé Duerme (Edición USA)"
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-154">
          <div className="my-10" data-id="element-155">
            <p className="text-muted mb-2 uppercase tracking-widest text-sm font-semibold" data-id="element-156">
              Pago Único
            </p>
            <div className="text-6xl md:text-7xl font-bold text-cream font-serif mb-4" data-id="element-157">
              $6.99{' '}
              <span className="text-2xl text-muted font-sans font-normal" data-id="element-158">
                USD
              </span>
            </div>
            <p className="text-lg text-gold/80 max-w-md mx-auto" data-id="element-159">
              Menos de lo que cuesta una consulta médica o una noche de café
              para mantenerte despierto.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} className="w-full flex justify-center mt-12" data-id="element-160">
          <CTAButton className="max-w-xl" href="https://colnexus.com/cart/43427213017294:1?checkout" data-id="element-161" />
        </FadeIn>
      </div>
    </section>;
}